// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1HCiY","question":"Question_question__3LilK","description":"Question_description__1_ToU"};